export const getClassNames = ({
  isDarkMode,
  hasMargins,
}: {
  isDarkMode: boolean;
  hasMargins: boolean;
}): string => {
  const classNames = [];
  if (isDarkMode) classNames.push("ds-dark");
  if (hasMargins) classNames.push("app-margins");
  return classNames.join(" ");
};
